import Handler from './components/index'

function App() {
    return <Handler />
}

export default App
